import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStockIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={40} height={40} fill='none' {...props}>
    <rect width={40} height={40} fill='#26C6DA' rx={8} />
    <g
      stroke='#fff'
      strokeLinecap='round'
      strokeMiterlimit={10}
      strokeWidth={1.5}
      clipPath='url(#stock-icon_svg__a)'
    >
      <path d='M20.984 19.278c-.08.3-.042.62.104.89s.387.47.673.553l1.19.3c.253.058.518.01.737-.135a1.03 1.03 0 0 0 .433-.639.95.95 0 0 0 .01-.645.9.9 0 0 0-.403-.489l-1.76-1.185a.9.9 0 0 1-.41-.487.95.95 0 0 1 .006-.647 1.03 1.03 0 0 1 .434-.64.95.95 0 0 1 .736-.134l1.19.32c.288.084.532.284.68.557.147.272.186.595.108.897M22.233 20.907l-.148.619M23.53 15.536l-.157.65' />
      <path d='m30.908 18.145-1.072 4.938c-.984 4.268-2.813 5.99-6.334 5.639a12 12 0 0 1-1.83-.32l-1.889-.474c-4.701-1.165-6.157-3.598-5.045-8.536l1.101-4.949c.184-.896.465-1.767.836-2.597 1.289-2.856 3.531-3.63 7.26-2.691l1.967.464c4.672 1.154 6.118 3.587 5.006 8.526Z' />
      <path d='M23.472 28.722c-.822.55-1.712.98-2.646 1.278l-1.78.619c-4.475 1.515-6.826.247-8.282-4.444l-1.446-4.67c-1.446-4.69-.246-7.165 4.23-8.68l1.78-.619c.462-.154.905-.278 1.318-.371a13 13 0 0 0-.836 2.598l-1.102 4.948c-1.101 4.939.354 7.372 5.046 8.536l1.889.475q.903.232 1.83.32z' />
    </g>
    <defs>
      <clipPath id='stock-icon_svg__a'>
        <path fill='#fff' d='M8 8h24v24H8z' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStockIcon;
